import { createVanIconComponent } from "./van"

const AddSquare = createVanIconComponent("add-square")
export default AddSquare
